import { render, staticRenderFns } from "./ReviewsManage.vue?vue&type=template&id=3bdad081&scoped=true"
import script from "./ReviewsManage.vue?vue&type=script&lang=js"
export * from "./ReviewsManage.vue?vue&type=script&lang=js"
import style0 from "./ReviewsManage.vue?vue&type=style&index=0&id=3bdad081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdad081",
  null
  
)

export default component.exports